

import React, { Component } from "react";
import { withRouter } from "./withRouter";
import  {  Popup } from "react-map-gl";


class NZ2026HomeTooltip extends Component {
 
  
             
buildTooltip(hoverInfo, styledGeo,tooltip_pastcomp) {
  const { geoLevel } = this.props; // 👈 bring it in
  if (!hoverInfo) return null;
  if (!styledGeo) return null;

  const { area_name, topLabel, area_id } = hoverInfo.props;

  // Find matching feature in styledGeo
  const comparatorFeature = styledGeo.features.find(
    f => f?.properties?.area_id === area_id
  );
  const comparator = comparatorFeature ? comparatorFeature?.properties : {};
  
  // Predicted vote shares (current prediction)
  const predictedValues = JSON.parse(hoverInfo.props._allValuesSorted);
  const Turnout = hoverInfo?.props?.Turnout? JSON.parse(hoverInfo?.props?.Turnout): null;

  const partyConfig = {
    nat_pred_n: { label: "National", color: "#0056A8" },
    act_pred_n: { label: "ACT", color: "#FFD700" },
    nzf_pred_n: { label: "NZF", color: "#000000" },
    lab_pred_n: { label: "Labour", color: "#E82C2C" },
    green_pred_n: { label: "Green", color: "#009639" },
    tpm_pred_n: { label: "TPM", color: "#CC0033" },
    oth_pred_n: { label: "Other", color: "#999999" }
  };

  // Build vote share lines
  const voteLines = predictedValues.map(({ key, area_id }) => {
  const party = partyConfig[key];
  if (!party) return null;

  // current prediction (%)
  const predicted = area_id.toFixed(0);

  // determine which "previous" source to use
  let prev = null;

  if (tooltip_pastcomp === "no") {
    // use past_vote_ columns from styledGeo properties
    // map pred key (e.g., 'act_pred_n') -> corresponding past_vote column
    const pastVoteKey = key.replace("_pred_n", "").replace(/^/, "past_vote_");
    prev = comparator?.[pastVoteKey] ?? null; // already normalised (%)
  } else {
    // use existing comparator (model-to-model comparison)
    prev = comparator[key] ? comparator[key] * 100 : null;
  }

  let change = "";
  if (prev !== null) {
    const diff = predicted - prev;
    change = ` (${diff > 0 ? "+" : ""}${diff.toFixed(0)}%)`;
  }

  return (
    <div key={key} style={{ color: party.color }}>
      {party.label}: {predicted}%
      {change}
    </div>
  );
});


  let area_type_label
  switch(geoLevel){
    case "constituency":
        area_type_label="Electorate"
        break
    default:
        area_type_label=geoLevel
        break
        
  }

  return (
    <div style={{ fontSize: "13px" }}>
      <strong>{area_name}</strong> {area_type_label}
      <br />
      Winner: {topLabel}
      <br />
      Turnout: {Turnout ? Turnout.toFixed(0) + "%" : "n/a"}
      <br />
      <br />
      <div>Predicted vote shares</div>
     <div>  (change from nominal 2023 result):</div>
      {voteLines}
      <br />
      <small>
        Click on an area to see how the Coalition is performing, or click a seat
        block to zoom in
      </small>
    </div>
  );
}






 

  render() {    
    const {  styledGeo,  hoverInfo} = this.props;

   
  return (
    <>
      {styledGeo && hoverInfo && hoverInfo?.props?.topValue>0 &&(
        <Popup
          longitude={hoverInfo.lon}
          latitude={hoverInfo.lat}
          closeButton={false}
          closeOnClick={false}
          offset={12}
          dynamicPosition={true}
          maxWidth="500px"
        >
          {this.buildTooltip(hoverInfo, styledGeo, this.props.tooltip_pastcomp)}
        </Popup>
      )}
    </>
  );
}
}
    
    export default withRouter(NZ2026HomeTooltip);
    